// extracted by mini-css-extract-plugin
module.exports = {"skeletonBone":"CustomSkeleton_skeletonBone__fXuSA","animationBar":"CustomSkeleton_animationBar__Cj7BK","customSkeleton":"CustomSkeleton_customSkeleton__C9Ist"};